import { _ as _defineProperty } from '../../unsorted/defineProperty.js';
import { _ as _objectWithoutProperties } from '../../unsorted/objectWithoutProperties.js';
import { useConvertSxToEmotionStyles } from '../../hooks/useConvertSxToEmotionStyles.js';
import { cloneElementWithCssProp } from '../../utils/componentHelpers.js';
import { jsx } from '@emotion/react/jsx-runtime';
import '@emotion/react';

var _excluded = ["testId", "sx", "children", "rc", "domRef", "className"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function Box(_ref) {
  var testId = _ref.testId,
    _ref$sx = _ref.sx,
    sx = _ref$sx === void 0 ? {} : _ref$sx,
    children = _ref.children,
    _ref$rc = _ref.rc,
    rc = _ref$rc === void 0 ? jsx("div", {}) : _ref$rc,
    domRef = _ref.domRef,
    className = _ref.className,
    domProps = _objectWithoutProperties(_ref, _excluded);
  var css = useConvertSxToEmotionStyles(sx);
  return cloneElementWithCssProp(rc, _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, domProps), testId ? {
    "data-testid": testId
  } : {}), domRef ? {
    ref: domRef
  } : {}), {}, {
    className: "".concat(className !== null && className !== void 0 ? className : "", " Box"),
    css: css,
    children: children
  }));
}
Box.displayName = "Box";

export { Box as B };
//# sourceMappingURL=Box.js.map
